export const MAINTENANCE_MODE_WEB_ENABLED = "maintenanceModeWebEnabled";
export const MAINTENANCE_MODE_WEB_MESSAGE = "maintenanceModeMessage";
